export interface ConditionOption {
  label: string
  value: string
}

export const CONDITION_OPTIONS: ConditionOption[] = [
  { label: 'New', value: 'new' },
  { label: 'Like New', value: 'like_new' },
  { label: 'Very Good', value: 'very_good' },
  { label: 'Good', value: 'good' },
  { label: 'Acceptable', value: 'acceptable' }
]
